var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-inline-block" },
    [
      _vm.size === "md"
        ? _c(
            "b-button",
            {
              staticClass: "fs-14 button-icon",
              class: `mt-${_vm.mt}`,
              attrs: { variant: "custom-green", title: "Информация о подписи" },
              on: {
                click: function ($event) {
                  _vm.showSignModal = true
                },
              },
            },
            [_c("b-icon-clipboard-check")],
            1
          )
        : _vm.size === "sm"
        ? _c("action-button-small", {
            attrs: { icon: "clipboard-check", title: "Информация о подписи" },
            on: {
              click: function ($event) {
                _vm.showSignModal = true
              },
            },
          })
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            visible: _vm.showSignModal,
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-footer": "",
            size: "md",
            title: _vm.title,
            "header-class": "pb-1",
            "body-class": "pt-1",
          },
          on: {
            close: function ($event) {
              _vm.showSignModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header-close",
              fn: function () {
                return [_c("button-close-modal")]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.customerSignature
            ? [
                _c("text-row", {
                  staticClass: "pl-0",
                  attrs: {
                    label: "Заказчик",
                    value: _vm.customerSignature.organization_name,
                    compact: "",
                  },
                }),
                _c("text-row", {
                  attrs: {
                    label: "ФИО",
                    value: _vm.customerSignature.user_name,
                    compact: "",
                  },
                }),
                _vm.customerSignature.poa_check_link
                  ? _c("text-row-link", {
                      attrs: {
                        label: "МЧД",
                        href: _vm.customerSignature.poa_check_link,
                        value: _vm.customerSignature.poa_number,
                        compact: "",
                      },
                    })
                  : _vm._e(),
                _c("text-row-datetime", {
                  attrs: {
                    label: "Дата и время",
                    value: _vm.customerSignature.sign_datetime,
                  },
                }),
                _c("div", { staticClass: "signature" }, [
                  _c("pre", { staticClass: "sign-text" }, [
                    _vm._v(
                      "                    " +
                        _vm._s(_vm.customerSignature.md5) +
                        "\n                "
                    ),
                  ]),
                ]),
                _vm.allowDownloadXml && _vm.customerSignature.xml
                  ? _c(
                      "b-button",
                      {
                        staticClass: "fs-14 mt-2",
                        class: `mt-${_vm.mt}`,
                        attrs: { variant: "custom-outline-secondary" },
                        on: {
                          click: function ($event) {
                            return _vm.downloadXml(
                              "customer_",
                              _vm.customerSignature.xml
                            )
                          },
                        },
                      },
                      [_vm._v("Скачать xml файл")]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.supplierSignature
            ? [
                _c("text-row", {
                  staticClass: "pl-0",
                  attrs: {
                    label: "Поставщик",
                    value: _vm.supplierSignature.organization_name,
                    compact: "",
                  },
                }),
                _c("text-row", {
                  attrs: {
                    label: "ФИО",
                    value: _vm.supplierSignature.user_name,
                    compact: "",
                  },
                }),
                _vm.supplierSignature.poa_check_link
                  ? _c("text-row-link", {
                      attrs: {
                        label: "МЧД",
                        href: _vm.supplierSignature.poa_check_link,
                        value: _vm.supplierSignature.poa_number,
                        compact: "",
                      },
                    })
                  : _vm._e(),
                _c("text-row-datetime", {
                  attrs: {
                    label: "Дата и время",
                    value: _vm.supplierSignature.sign_datetime,
                  },
                }),
                _c("div", { staticClass: "signature" }, [
                  _c("pre", { staticClass: "sign-text" }, [
                    _vm._v(
                      "                    " +
                        _vm._s(_vm.supplierSignature.md5) +
                        "\n                "
                    ),
                  ]),
                ]),
                _vm.allowDownloadXml && _vm.supplierSignature.xml
                  ? _c(
                      "b-button",
                      {
                        staticClass: "fs-14 mt-2",
                        class: `mt-${_vm.mt}`,
                        attrs: { variant: "custom-outline-secondary" },
                        on: {
                          click: function ($event) {
                            return _vm.downloadXml(
                              "supplier_",
                              _vm.supplierSignature.xml
                            )
                          },
                        },
                      },
                      [_vm._v("Скачать xml файл")]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }